<div class="icon">
    <app-icon [simple]="true"
              type="info"
              library="fontawesome"
              [variant]="icon">
    </app-icon>
</div>
<div class="info">
    <p class="title">{{ title }}</p>
    <div class="actions">
        <app-icon [simple]="true"
                  type="info"
                  library="fontawesome"
                  variant="fa-file-pdf-o"
                  pTooltip="Download PDF"
                  (click)="doSelect('pdf', pdfUrl)">
        </app-icon>
        <app-icon [simple]="true"
                  type="info"
                  library="fontawesome"
                  variant="fa-file-text"
                  pTooltip="Download DocX"
                  (click)="doSelect('docx', docUrl)">
        </app-icon>
    </div>
</div>
<div class="remove">
    <app-icon [simple]="true"
              type="danger"
              library="fontawesome"
              variant="fa-remove"
              (click)="doRemove()">
    </app-icon>
</div>
